export default "__VITE_ASSET__CYu9p_Qq__"